import { render, staticRenderFns } from "./CircleProgressBar.vue?vue&type=template&id=4b087cf8&"
import script from "./CircleProgressBar.vue?vue&type=script&lang=js&"
export * from "./CircleProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./CircleProgressBar.vue?vue&type=style&index=0&id=4b087cf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports